export default __webpack_public_path__ + "static/media/contact-img.da1eeca3.jpg";